import React, { useState } from 'react';
import { Menu, Phone, X } from 'lucide-react';
import { business } from '../data/business';
type HeaderProps = {
  logoVariant: 'badge' | 'wordmark';
};
const links = [{
  label: 'Services',
  href: '#services'
}, {
  label: 'Why Us',
  href: '#why-us'
}, {
  label: 'About Mason',
  href: '#about'
}, {
  label: 'Reviews',
  href: '#reviews'
}, {
  label: 'Service Area',
  href: '#area'
}];
export function Header({
  logoVariant
}: HeaderProps) {
  const [open, setOpen] = useState(false);
  return <header className="sticky top-0 z-40 w-full border-b border-brand-navy/10 bg-white/95 backdrop-blur" data-id="element-63" data-mp="2wkgri2t5v8w6">
      <div className="hidden bg-brand-navy sm:block" data-id="element-64" data-mp="31d0715bese3m">
        <div className="mx-auto flex max-w-7xl items-center justify-between px-5 py-2 lg:px-8" data-id="element-65" data-mp="36b208j2jttst">
          <p className="text-xs font-bold uppercase tracking-[0.18em] text-white/70" data-id="element-66" data-mp="36cwddb7kwhmc">
            {business.tagline} · {business.city}
          </p>
          <p className="text-xs font-bold uppercase tracking-[0.18em] text-brand-light" data-id="element-67" data-mp="3fcrnrdtb88lb">
            Free estimates · {business.hours}
          </p>
        </div>
      </div>
      <div className="mx-auto flex h-20 max-w-7xl items-center justify-between gap-4 px-5 lg:px-8" data-id="element-68" data-mp="2rl8bwsahmh16">
        <a href="#top" className="flex items-center gap-3" aria-label={business.name} data-id="element-69" data-mp="2mm5635moo6s5">
          {logoVariant === 'wordmark' ? <img src={business.logoFull} alt={`${business.name} logo`} className="h-14 w-auto" data-id="element-70" data-mp="2hovg9ovdtt3s" /> : <>
              <img src={business.logoBadge} alt="" className="h-12 w-12 rounded-full ring-1 ring-brand-navy/10" data-id="element-71" data-mp="3adaitbxbuiy8" />
              <span className="font-display text-lg leading-none tracking-tight text-brand-navy sm:text-xl" data-id="element-72" data-mp="30mpqu7c5scoa">
                BUCKET HAT{' '}
                <span className="text-brand-blue" data-id="element-73" data-mp="1y0mkkg4c7yd">CLEANING</span>
              </span>
            </>}
        </a>

        <nav className="hidden items-center gap-7 lg:flex" aria-label="Main" data-id="element-74" data-mp="3t90p3bcam1hx">
          {links.map(link => <a key={link.href} href={link.href} className="text-sm font-semibold text-brand-navy/70 transition-colors hover:text-brand-blue" data-id="element-75" data-mp="1rfxkiqx3bmaz">
              {link.label}
            </a>)}
        </nav>

        <div className="flex items-center gap-3" data-id="element-76" data-mp="1mla3te8bvw6y">
          <a href={business.phoneHref} className="hidden items-center gap-2 text-sm font-bold text-brand-navy sm:flex" data-id="element-77" data-mp="18nboo6m6nvqe">
            <Phone className="h-4 w-4 text-brand-blue" aria-hidden="true" data-id="element-78" data-mp="1cq01sqhxjot6" />
            {business.phone}
          </a>
          <a href="#quote" className="hidden rounded-full bg-brand-blue px-5 py-3 text-sm font-bold text-white shadow-sm transition-colors hover:bg-brand-blue-dark sm:inline-block" data-id="element-79" data-mp="yr8o356zc55k">
            Get a Free Estimate
          </a>
          <button type="button" onClick={() => setOpen(v => !v)} className="inline-flex h-11 w-11 items-center justify-center rounded-xl border border-brand-navy/15 text-brand-navy lg:hidden" aria-expanded={open} aria-label={open ? 'Close menu' : 'Open menu'} data-id="element-80" data-mp="2y0p16j4g8q2l">
            {open ? <X className="h-5 w-5" data-id="element-81" data-mp="w6amlh57k6w3" /> : <Menu className="h-5 w-5" data-id="element-82" data-mp="rd7sn7wiqvfd" />}
          </button>
        </div>
      </div>

      {open && <div className="border-t border-brand-navy/10 bg-white px-5 py-4 lg:hidden" data-id="element-83" data-mp="154cxqpinofx3">
          <nav className="flex flex-col" aria-label="Mobile" data-id="element-84" data-mp="106bbxwtui2hx">
            {links.map(link => <a key={link.href} href={link.href} onClick={() => setOpen(false)} className="border-b border-brand-navy/5 py-3 text-base font-semibold text-brand-navy" data-id="element-85" data-mp="1f324bm53qdy1">
                {link.label}
              </a>)}
          </nav>
          <a href="#quote" onClick={() => setOpen(false)} className="mt-4 block rounded-full bg-brand-blue px-5 py-3 text-center text-base font-bold text-white" data-id="element-86" data-mp="3bwnhpiac71qf">
            Get a Free Estimate
          </a>
        </div>}
    </header>;
}